module.exports = __webpack_public_path__ + "static/media/guidance_6.887875e5.png";